<script setup lang="ts">
  import { ref } from 'vue';
  import { storeToRefs } from 'pinia';
  import { useUserStore } from '@/stores';
  import { fetchWrapper } from '@/helpers';
  const userStore = useUserStore();
  const { course, logoutUrl } = storeToRefs(userStore);
  const isLoggingOut = ref(false);

  const logout = () => {
    isLoggingOut.value = true;
    // Remove access_token cookie
    fetchWrapper
      .get('/studentapp/auth/logout')
      .then((results) => console.log(results))
      .catch((error) => console.error(error));
    window.location.assign(logoutUrl.value);
  };
  const logoPath = '/studentapp/images/capsim-logo.svg';
</script>
<template>
  <div>
    <img :src="logoPath" class="m-auto pt-2 pb-3" alt="Capsim Logo" />
    <nav class="bg-sky-700">
      <div class="mx-auto container px-2 sm:px-6 lg:px-8">
        <div class="relative flex h-12 items-center justify-between">
          <div class="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
            <div class="flex flex-shrink-0 items-center inline-block text-white">
              Welcome {{ course.firstName }} {{ course.lastName }}
            </div>
          </div>
          <button
            type="button"
            @click="logout"
            :disabled="isLoggingOut"
            class="btn btn-blue btn-sm bg-sky-700 my-1"
          >
            Log Out
          </button>
        </div>
      </div>
    </nav>
  </div>
</template>
